import { render } from "./IconMultiviewLayout.vue?vue&type=template&id=189fcf49"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconMultiviewLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "189fcf49"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('189fcf49', __exports__)) {
    api.reload('189fcf49', __exports__)
  }
  
  module.hot.accept("./IconMultiviewLayout.vue?vue&type=template&id=189fcf49", () => {
    api.rerender('189fcf49', render)
  })

}


export default __exports__